import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class DiscountSummaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DiscountSummaryError', ...args);
    }
}
export default DiscountSummaryError;
